<template>

  <div>
    <div class="row">
      <div class="col s12 m8 l10 xl10">
        <div class="row">
          <div class="input-field col s12">
            <i class="material-icons prefix ">search</i>
            <input id="search" type="text" class="validate" v-model="filterTerm">
            <label for="search">Pesquisar</label>
          </div>
        </div>
      </div>
         <div class="col s12 m4 l2 xl2">
        <a  data-tooltip="Adicionar uma atuação." href="/atuacaos/create" class="cyan waves-effect waves-light btn-small left tooltipped">
          <i class="material-icons">add</i></a>
        </div>

    </div>

    <div class="row">
      <div class="col s12 m12 l12 xl12">

        <!-- <pre>{{ [sortProperty, sortDirection, sortPropertyId] | json }}</pre> -->

        <table>
          <thead>
            <tr>
              <th class="hide-on-med-and-down">
                #
                <a class="left" href="#" @click="toggleOrder($event, 'id')">
                  <i class="material-icons" v-bind:class="{ 'red-text': sortPropertyId }" >sort</i>
                </a>
              </th>
              <th>
                Nome
                <a class="left" href="#" @click="toggleOrder($event, 'nome')">
                  <i class="material-icons" v-bind:class="{ 'red-text': sortPropertyNome }" >sort</i>
                </a>
              </th>
              <th>
                tipo
                <a class="left" href="#" @click="toggleOrder($event, 'tipo_formatado')">
                  <i class="material-icons" v-bind:class="{ 'red-text': sortPropertyTipo }" >sort</i>
                </a>
              </th>
              <th>
                Edit.
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="atuacao in filteredAtuacaos">
              <td >{{ atuacao.id }}</td>
              <td>{{ atuacao.nome }}</td>
              <td>{{ atuacao.tipo_formatado }}</td>
              <td>
                <a data-tooltip="Editar uma atuação" :href="'/atuacaos/'+atuacao.id+'/edit'"
                class="waves-effect waves-light btn-small tooltipped">
                  <i class="material-icons">edit</i>
                </a>
			  </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "VueAtuacaos",
      props: [
        'atuacaos',
      ],
      data () {
        return {
          listaAtuacaos: JSON.parse(this.atuacaos),
		      sortProperty: 'id',
          sortDirection: 'asc',
          filterTerm: '',
          sortPropertyId: true,
          sortPropertyNome: false,
          sortPropertyTipo: false,
        }
      },
      computed: {
        listatuacaosOp: function () {
          this.listaAtuacaos = _.orderBy(this.listaAtuacaos, this.sortProperty, this.sortDirection)
        },
        filteredAtuacaos:function () {
          var self = this
          return _.orderBy(self.listaAtuacaos.filter(function (atuacao) {
            var searchRegex = new RegExp(self.filterTerm, 'i')
            return (
              searchRegex.test(atuacao.id) ||
              searchRegex.test(atuacao.nome) ||
              searchRegex.test(atuacao.tipo_formatado)

            )
          }), this.sortProperty, this.sortDirection)
        },
      },
      methods: {
        toggleOrder (ev, field) {
          ev.preventDefault()
          if (this.sortProperty == field){
            if (this.sortDirection == 'asc')
              this.sortDirection = 'desc'
            else
              this.sortDirection = 'asc'
          } else {
            this.iconsColor(this.sortProperty, false)
            this.iconsColor(field, true)
            this.sortProperty = field
            this.sortDirection = 'asc'
          }
        },
        iconsColor(field, value){
          switch (field) {
            case 'id':
              this.sortPropertyId = value
              break;
            case 'nome':
              this.sortPropertyNome = value
              break;
            case 'tipo_formatado':
              this.sortPropertyTipo= value
              break;
            default:
          }
        },
        onDelete(atuacao){
          $.ajax({
            headers:{
              'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
            },
            method:"DELETE",
            url:"/atuacaos/"+atuacao.id,
            success:function(result){
              showMsg(atuacao.nome+' foi removido com sucesso.', 200);
              window.setTimeout('window.location="/atuacaos"',1000);
            },
			error:function(result){
				if (result.status == 405)
					showMsg('Não é possível excluir o atuacao ' + atuacao.nome + ' porque possui unidades!', 0);
				else
					showMsg('Erro interno ao excluir o atuacao ' + atuacao.nome + '. Entre em contato com o administrador!', 0);
			  //window.setTimeout('window.location="/atuacaos"',10000);
            }
          });
        }
      }

    }

</script>
